import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { UserPreferencesSecurity } from '../components/UserPreferencesSecurity';
import { getGatesFromAuth } from '../selectors/AuthSelector';
import UserPreferencesPage from './UserPreferencesPage';
import { jsx as _jsx } from "react/jsx-runtime";
const UserPreferencesSecurityContainer = ({
  gates
}) => /*#__PURE__*/_jsx(UserPreferencesPage, {
  loadWithErrors: true,
  children: /*#__PURE__*/_jsx(UserPreferencesSecurity, {
    gates: gates
  })
});
const mapStateToProps = createStructuredSelector({
  gates: getGatesFromAuth
});
export default connect(mapStateToProps)(UserPreferencesSecurityContainer);